<template>
  <div>
    <GlobalInfoBar>
      会员订单列表
    </GlobalInfoBar>
    <GlobalChunk :padding="[20, 20, 20, 20]">

      <GlobalForm :form-item-list="formItemList" :inline="true" round @handleConfirm="query" confirmBtnName="查询"
        @handleChange="searchChange" ref="searchForm">
        <div slot="AddBtn">
          <el-button size="small" type="primary" @click="clearAllSearch()" round>清空</el-button>
        </div>
      </GlobalForm>

      <div style="width: 100%;display: flex;justify-content: end;padding: 15px;">
        <el-button type="success" @click="download()" :loading="downloading">导出</el-button>
      </div>
      <GlobalTable ref="GlobalTable" :columns="tableColumns" :data="tableData" :currentPage="curPage" :total="total"
        @handleCurrentChange="currentChange">
        <el-table-column label="操作" slot="operation" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="info(row)">查看详情</el-button>
            <el-button type="primary" size="small" @click="goToVerificationRecord(row)">核销记录</el-button>
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>


  </div>
</template>

<script>


import {
  userCard, storeDrop, shopDrop, userDownload
} from "@/utils/request/membershipSystem";

export default {
  name: "list",
  data() {
    return {
      formItemList: [
        {
          key: 'card_number',
          type: 'input',
          labelName: '会员号：',
          placeholder: '请输入会员号'
        },
        {
          key: 'plan_title',
          type: 'input',
          labelName: '会员方案名称:',
          placeholder: '请输入会员方案名称'
        },
        {
          key: 'name',
          type: 'input',
          labelName: '会员名称:',
          placeholder: '请输入会员名称'
        },
        {
          key: 'phone',
          type: 'input',
          labelName: '会员手机号:',
          placeholder: '请输入会员手机号'
        },
        {
          key: 'time',
          type: 'daterange',
          labelName: '时间:',
        },
        {
          key: 'store_id',
          idKey: 'store_id',
          labelKey: 'store_name',
          type: 'selectFilterable',
          labelName: '所属门店商:',
          option: [],
          placeholder: '请选择所属门店商'
        },
        {
          key: 'shop_id',
          idKey: 'shop_id',
          labelKey: 'shop_name',
          type: 'selectFilterable',
          labelName: '所属门店:',
          option: [],
          readonly: true,
          placeholder: '请选择所属门店'
        },
        {
          key: 'staff_name',
          type: 'input',
          labelName: '店员名称:',
          placeholder: '请输入店员名称'
        },
        {
          key: 'staff_phone',
          type: 'input',
          labelName: '店员手机号:',
          placeholder: '请输入店员手机号'
        },
        {
          key: 'imei',
          type: 'input',
          labelName: '购机串号:',
          placeholder: '请输入购机串号'
        },
      ],
      tableColumns: [
        { label: "会员卡号", prop: "card_number" },
        { label: "会员方案名称", prop: "plan_title" },
        { label: "支付金额", prop: "amount" },
        { label: "卡面储值额", prop: "parvalue" },
        { label: "会员名称", prop: "name" },
        { label: "会员手机号", prop: "phone" },
        { label: "所属门店商", prop: "store_name" },
        { label: "申请门店", prop: "shop_name" },
        { label: "申请店员", prop: "staff_name" },
        { label: "店员手机号", prop: "staff_phone" },
        { label: "购机串号", prop: "imei" },
        { label: "申请时间", prop: "add_time" },
        { label: "当前储值余额", prop: "balance" },
        { label: "是否注册服务", prop: "is_order" },
        { slotName: "operation" },

      ],
      tableData: [],
      curPage: 1,
      total: 0,
      searchData: {},
      downloading: false

    }
  },
  mounted() {
    this.userCard()
    this.storeDrop()
  },
  watch: {


  },
  methods: {
    storeDrop() {
      storeDrop().then(res => {
        this.formItemList[5].option = res.data || []
      })
    },
    userCard() {
      userCard({
        page: this.curPage,
        ...this.searchData
      }).then(res => {
        this.tableData = res.data || []
        this.total = res.count || 0
      })
    },
    currentChange(page) {
      this.curPage = page
      this.userCard()
    },
    searchChange(item, value) {
      console.log(item, value);
      if (item.idKey == 'store_id' && value == '') {
        this.formItemList[6].option = []
        this.formItemList[6].readonly = true
        this.searchData.shop_id = null
      } else if (item.idKey == 'store_id') {
        this.formItemList[6].readonly = false

        shopDrop({
          store_id: value
        }).then(res => {
          this.formItemList[6].option = res.data || []
        })
      }

    },
    query(val) {
      console.log(val);
      const { time } = val
      this.searchData = {
        beg_time: time ? Date.parse(time[0]) : '',
        end_time: time ? Date.parse(time[1]) : '',
        ...val
      }
      this.userCard()
    },
    clearAllSearch() {
      this.$refs.searchForm.clear()
    },
    download() {
      const { time } = this.$refs.searchForm.formData
      const DownLoadSearch = {
        beg_time: time ? Date.parse(time[0]) : '',
        end_time: time ? Date.parse(time[1]) : '',
        ...this.$refs.searchForm.formData
      }
      this.downloading = true
      userDownload(DownLoadSearch).then((res) => {
        this.downloading = false
        const content = res;
        const blob = new Blob([content]);
        const fileName = "会员订单列表.xls";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    info(row) {
      const { card_id } = row
      this.$router.push({ path: '/membershipSystem/memberDetails', query: { card_id } });
    },
    goToVerificationRecord(row) {
      const { card_number } = row
      this.$router.push({ path: '/membershipSystem/verificationList', query: { card_number } });

    }
  }
}
</script>

<style scoped lang="scss"></style>